// AUTO-GENERATED by scripts/generate-tokens.mjs — DO NOT EDIT.
// Source of truth: src/theme/design-tokens.generated.json (key: typography)
//   <- beoflow-design-tokens-sync (Drafted "Beoflow Design System" / foundations/typography)
// Regenerate: npm run tokens:gen   (no-drift gate: npm run tokens:check)
//
// The .generated suffix means DO NOT HAND-EDIT. These are the Beoflow typography tokens.
// Mirrors the iOS Beoflow/Theme/ files; values are web-idiomatic (hex/rgba, numeric weights, px).

export const fontFamilies = {
  raleway: 'Raleway',
  ibmPlexMono: 'IBM Plex Mono',
  system: 'system-ui',
  orbitron: 'Orbitron',
  eurostile: 'Eurostile Extended Black',
} as const;

/** Text styles. fontWeight is numeric (CSS); fontFamily is the raw family name. */
export const textStyles = {
  heading1: { fontFamily: 'Raleway', fontWeight: 600, fontSize: 24, lineHeight: 32 },
  heading2: { fontFamily: 'Raleway', fontWeight: 600, fontSize: 20, lineHeight: 28 },
  heading3: { fontFamily: 'Raleway', fontWeight: 600, fontSize: 16, lineHeight: 24 },
  heading4: { fontFamily: 'Raleway', fontWeight: 600, fontSize: 14, lineHeight: 22 },
  body: { fontFamily: 'Raleway', fontWeight: 400, fontSize: 14, lineHeight: 22 },
  bodyMedium: { fontFamily: 'Raleway', fontWeight: 500, fontSize: 14, lineHeight: 22 },
  bodySmall: { fontFamily: 'Raleway', fontWeight: 400, fontSize: 12, lineHeight: 16 },
  bodyTiny: { fontFamily: 'Raleway', fontWeight: 400, fontSize: 10, lineHeight: 16 },
  label: { fontFamily: 'Raleway', fontWeight: 600, fontSize: 10, letterSpacing: 1, textTransform: 'uppercase' },
  cardTitle: { fontFamily: 'Raleway', fontWeight: 600, fontSize: 16 },
  cardDescription: { fontFamily: 'Raleway', fontWeight: 400, fontSize: 12 },
  cardSportLabel: { fontFamily: 'Raleway', fontWeight: 500, fontSize: 8, textTransform: 'uppercase' },
  dataHighlight: { fontFamily: 'system-ui', fontWeight: 500, fontSize: 32, lineHeight: 32, letterSpacing: -0.7 },
  metricLarge: { fontFamily: 'system-ui', fontWeight: 500, fontSize: 36 },
  metricSecondary: { fontFamily: 'system-ui', fontWeight: 500, fontSize: 16 },
  dataUnit: { fontFamily: 'IBM Plex Mono', fontWeight: 400, fontSize: 10, textTransform: 'uppercase' },
  graphData: { fontFamily: 'IBM Plex Mono', fontWeight: 400, fontSize: 12, lineHeight: 12, textTransform: 'uppercase' },
  button: { fontFamily: 'IBM Plex Mono', fontWeight: 400, fontSize: 16, lineHeight: 16, letterSpacing: 0.5, textTransform: 'uppercase' },
  navigation: { fontFamily: 'IBM Plex Mono', fontWeight: 400, fontSize: 16, letterSpacing: 0.5, textTransform: 'uppercase' },
  sectionHeader: { fontFamily: 'IBM Plex Mono', fontWeight: 600, fontSize: 12, letterSpacing: 1, textTransform: 'uppercase' },
  navTitle: { fontFamily: 'Orbitron', fontWeight: 900, fontSize: 16, letterSpacing: -0.5, textTransform: 'uppercase' },
} as const;
export type BeoflowTextStyleName = keyof typeof textStyles;
